import React, { useMemo, useState } from "react";
import { OPTIONS, STATUS_OPTIONS } from "./config";

const Filter = (props) => {
  const { filters, updateFilter, updateMultipleFilters } = props;
  const [searchText, setSearchText] = useState(filters.text || "");

  const onDropdownChange = (value) => {
    updateMultipleFilters({
      keyword: value,
      text: searchText,
    });
  };

  const onSearchChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
    if (value.trim() === "") {
      updateFilter("text", "");
    } else {
      updateFilter("text", value);
    }
  };

  const filterVal = useMemo(() => {
    return (
      OPTIONS.find((option) => option.key === filters.keyword)?.value || ""
    );
  }, [filters]);

  const statusVal = useMemo(() => {
    return (
      STATUS_OPTIONS.find((option) => option.key === filters.is_active)
        ?.value || ""
    );
  }, [filters]);

  return (
    <>
      <div className="dropdown ms-3">
        <button
          className="dropdown-toggle btn active"
          data-bs-toggle="dropdown"
        >
          {statusVal}
        </button>
        <ul className="dropdown-menu">
          {STATUS_OPTIONS.map(({ key, value }) => (
            <li
              className="dropdown-item"
              onClick={() => updateFilter("is_active", key)}
              key={key}
            >
              {value}
            </li>
          ))}
        </ul>
      </div>
      <div className="dropdown ms-3">
        <button
          className="dropdown-toggle btn btn-o box-shadow-none active"
          data-bs-toggle="dropdown"
        >
          {filterVal}
        </button>
        <ul className="dropdown-menu">
          {OPTIONS.map(({ key, value }) => (
            <li
              className="dropdown-item"
              onClick={() => onDropdownChange(key)}
              key={key}
            >
              {value}
            </li>
          ))}
        </ul>
      </div>
      <div className="input-group ms-3">
        <input
          type="search"
          placeholder="Search something"
          className="form-control"
          value={searchText}
          onChange={onSearchChange}
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
        />
      </div>
    </>
  );
};

export default Filter;
